import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
  computed,
  input,
  output,
} from '@angular/core';
import { MatButton } from '@angular/material/button';
import { SiaTranslatePipe } from '@sia/shared';
import { SiaBaseEditorSignalComponent } from '../sia-base-editor/sia-base-editor-signal.component';

@Component({
  selector: 'sia-button',
  templateUrl: './sia-button.component.html',
  styleUrls: ['./sia-button.component.scss'],
  standalone: true,
  imports: [MatButton, SiaTranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SiaButtonComponent extends SiaBaseEditorSignalComponent {
  color = input<'accent' | 'primary' | 'warn'>('primary');
  icon = input<string | undefined>();
  enableDot = input(false);

  colorVars = computed(() => {
    const c = this.color();
    const palette = {
      primary: {
        container: 'var(--mat-sys-primary)',
        label: 'var(--mat-sys-on-primary)',
      },
      accent: {
        container: 'var(--sia-warning)',
        label: 'var(--sia-on-warning)',
      },
      warn: {
        container: 'var(--mat-sys-error)',
        label: 'var(--mat-sys-on-error)',
      },
    } as const;

    return palette[c] ?? palette.primary;
  });

  @HostListener('window:unload')
  ngOnDestroy() {}

  readonly onButtonClick = output<MouseEvent>();
  onClick(event: MouseEvent) {
    if (this.isDisabled()) {
      return;
    }
    this.onButtonClick.emit(event);
  }
}
